module.exports = __webpack_public_path__ + "assets/images/project/lower-pierce-reservoir/01.jpg?v=9176cdc9";